export default function (
  state = { open: false, search: false, filters: {}, searchString: "" },
  action
) {
  switch (action.type) {
    case "SEARCH_OPEN":
      return Object.assign({}, state, {
        open: true,
      });
    case "SEARCH_CLOSE":
      return Object.assign({}, state, {
        open: false,
      });
    case "SET_FILTERS":
      return Object.assign({}, state, {
        filters: action.filters,
      });
    case "SET_SEARCH":
      return Object.assign({}, state, {
        search: action.search,
      });
    case "SET_SEARCH_STRING":
      return Object.assign({}, state, {
        searchString: action.string,
      });
    default:
      return state;
  }
}
